import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function ModalHeaderViewer(props) {
  return (
    <Modal.Header {...props}>
      {props.children}
    </Modal.Header>
  )
}